import {
    HttpClient,
    HttpErrorResponse,
    HttpParams
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PromiseResult } from '../models/PromiseResult';
import { RestApi } from '../shared/apiUrls';

@Injectable({
    providedIn: 'root'
})
export class ZoomService {
    constructor(private readonly http: HttpClient) {}

    private handleError(error: HttpErrorResponse) {
        return throwError(error);
    }

    GetCovidMeetLink(): Observable<PromiseResult> {
        return this.http
            .get<PromiseResult>(RestApi.Urls.ZoomApi + 'Get/covid_meeting_link')
            .pipe(catchError(this.handleError));
    }
    GetSpecialZoomLink(): Observable<PromiseResult> {
        return this.http
            .get<PromiseResult>(RestApi.Urls.ZoomApi + 'freeconsultation/timings/fetch')
            .pipe(catchError(this.handleError));
    }
}
